/**
 * Si esta persona ya ha visto el tutorial de bienvenida.
 *
 * Se guarda en el navegador, por usuario. Es una comodidad, no un dato del
 * negocio: si alguien entra desde otro aparato lo verá otra vez (y puede
 * omitirlo en un clic), y siempre puede repetirlo desde el menú de su
 * avatar → «Ver el tutorial».
 *
 * Si el almacenamiento está bloqueado (modo privado estricto) NO se enseña:
 * sin poder recordar que ya se vio, saldría en cada visita, que es peor que
 * no salir nunca.
 */
const clave = (usuarioId: string) => `obralink:tutorial-visto:${usuarioId}`;

export function tutorialVisto(usuarioId: string): boolean {
  try {
    return localStorage.getItem(clave(usuarioId)) !== null;
  } catch {
    return true;
  }
}

export function marcarTutorialVisto(usuarioId: string): void {
  try {
    localStorage.setItem(clave(usuarioId), new Date().toISOString());
  } catch {
    /* nada que hacer */
  }
}
